import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  openServiceJourney(title: string): void {
    const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    const targetUrl = `/services/${slug}`;

    if (window.location.pathname.replace(/\/+$/, '') === targetUrl) {
      window.location.reload();
      return;
    }

    window.location.assign(targetUrl);
  }
}
